module.exports = __webpack_public_path__ + "img/18.2ca8fb16.png";